import { createSlice } from "@reduxjs/toolkit";
import type { Font } from "../../models/fonts";
import { getFonts } from "../thunks/fontsThunks";

export interface FontsState {
  fontsLoading: boolean;
  fontsError: string | null;
  fonts: Font[];
}

const initialState: FontsState = {
  fontsLoading: false,
  fontsError: null,
  fonts: [],
};

const fontsSlice = createSlice({
  name: "fonts",
  initialState,
  reducers: {
    clearFontsError: (state) => {
      state.fontsError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFonts.pending, (state) => {
        state.fontsLoading = true;
        state.fontsError = null;
      })
      .addCase(getFonts.fulfilled, (state, action) => {
        state.fontsLoading = false;
        state.fonts = action.payload.fonts;
      })
      .addCase(getFonts.rejected, (state, action) => {
        state.fontsLoading = false;
        state.fontsError =
          action.payload || action.error.message || "Failed to fetch fonts";
      });
  },
});

export const { clearFontsError } = fontsSlice.actions;
export default fontsSlice.reducer;
